import { BaseGameDrawer } from './BaseGameDrawer';

class GameLandscapeDrawer extends BaseGameDrawer {

}
export const gameLandscapeDrawer = new GameLandscapeDrawer();
